import * as PopoverPrimitive from "@radix-ui/react-popover";
import type { ComponentProps } from "react";

import { OverlayLayerProvider, useOverlayZIndex } from "../../lib/overlay-z-index";
import { cn } from "../../lib/utils";

export type PopoverContentProps = ComponentProps<typeof PopoverPrimitive.Content>;

export const PopoverContent = ({
  className,
  align = "center",
  sideOffset = 4,
  style,
  ...props
}: PopoverContentProps) => {
  const { z, style: zStyle, className: zClassName } = useOverlayZIndex("popover");

  return (
    <PopoverPrimitive.Portal>
      <OverlayLayerProvider base={z}>
        <PopoverPrimitive.Content
          data-slot="popover-content"
          align={align}
          sideOffset={sideOffset}
          // Spread `zStyle` last so a caller's `style` can't clobber the `--z` that drives stacking.
          style={{ ...style, ...zStyle }}
          className={cn(
            // `origin-(…)` and `outline-hidden` are Tailwind v4 syntax; on our Tailwind 3 they compile
            // to nothing. Kept verbatim so migrating doesn't change the rendered result.
            "w-72 origin-(--radix-popover-content-transform-origin) rounded-[10px] border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
            zClassName,
            className
          )}
          {...props}
        />
      </OverlayLayerProvider>
    </PopoverPrimitive.Portal>
  );
};
